import React from 'react';
import { useNavigate } from 'react-router-dom';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardActionArea from '@mui/material/CardActionArea';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
// Iconos apropiados para inventario
import AddBoxIcon from '@mui/icons-material/AddBox';
import InputIcon from '@mui/icons-material/Input';
import InventoryIcon from '@mui/icons-material/Inventory';

function Inventory() {
  const navigate = useNavigate();

  const cardStyle = {
    maxWidth: 275,
    height: 180,
    boxShadow: '0 4px 12px rgba(75, 0, 130, 0.15)',
    borderRadius: '12px',
    transition: 'all 0.3s ease',
    '&:hover': {
      transform: 'translateY(-4px)',
      boxShadow: '0 8px 24px rgba(75, 0, 130, 0.25)',
    }
  };

  const iconStyle = {
    fontSize: 40,
    color: '#4b0082',
    opacity: 0.8
  };

  const InventoryMenuOptions = [
    {
      title: 'Agregar Prenda',
      description: 'Agrega un nuevo articulo al inventario.',
      path: `/inventory/add-item`,
      icon: <AddBoxIcon sx={iconStyle} />
    },
    {
      title: 'Vestidos pendientes',
      description: 'Registra la devolución de un vestido alquilado.',
      path: `/inventory/pending-items/dresses`,
      icon: <InputIcon sx={iconStyle} />
    },
    {
      title: 'Trajes pendientes',
      description: 'Registra la devolución de un traje alquilado.',
      path: `/inventory/pending-items/suits`,
      icon: <InputIcon sx={iconStyle} />
    },
    {
      title: 'Inventario',
      description: 'Muestra el inventario completo de artículos de alquiler.',
      path: `/inventory/view-items`,
      icon: <InventoryIcon sx={iconStyle} />
    }
  ];

  const handleNavigate = (path) => {
    setTimeout(() => {
      navigate(path)
    }, 100)
  }

  return (
    <div className='events-menu-main-container'>
      <div className='events-menu-container'>
        {InventoryMenuOptions.length > 0 && InventoryMenuOptions.map((option, index) => (
          <div className='event-reservation grid-obj' key={index}>
            <Card sx={cardStyle}>
              <CardActionArea sx={{ height: 180 }} onClick={() => handleNavigate(option.path)}>
                <CardContent sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  height: 150,
                  justifyContent: 'space-between',
                  padding: '20px'
                }}>
                  <div className='content-container'>
                    <Typography sx={{
                      color: '#4b0082',
                      fontWeight: 'bold',
                      marginBottom: '8px'
                    }} gutterBottom variant="h5" component="div">
                      {option.title}
                    </Typography>
                    <Typography variant="body2" sx={{
                      color: 'text.secondary',
                      lineHeight: 1.4,
                      textAlign: 'justify'
                    }}>
                      {option.description}
                    </Typography>
                  </div>
                  <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                    {option.icon}
                  </Box>
                </CardContent>
              </CardActionArea>
            </Card>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Inventory;